// pageIndex: 第幾頁
// pageSize:  一頁幾筆
import { NOTIFICATIONS_ROUTER } from "@icoach/router/routerPath";
import { NOTIFICATION_SOURCE_TYPE } from "@icoach/constants/";

export const initBookmark = () => ({
	pageIndex: 1,
	pageSize: 50,
});

export const notificationMenus = [
	{ menuText: "全部", sourceType: NOTIFICATION_SOURCE_TYPE.ALL, router: NOTIFICATIONS_ROUTER.ENTIRE },
	{ menuText: "會籍移入", sourceType: NOTIFICATION_SOURCE_TYPE.TRANSFERIN, router: NOTIFICATIONS_ROUTER.TRANSFERIN },
	{ menuText: "會籍移出", sourceType: NOTIFICATION_SOURCE_TYPE.TRANSFEROUT, router: NOTIFICATIONS_ROUTER.TRANSFEROUT },
	{ menuText: "會籍到期", sourceType: NOTIFICATION_SOURCE_TYPE.MEMBERSHIPEXPIRED, router: NOTIFICATIONS_ROUTER.MEMBERSHIP_EXPIRE },
	{ menuText: "發票異常", sourceType: NOTIFICATION_SOURCE_TYPE.INVOICE, router: NOTIFICATIONS_ROUTER.INVOICE },
	{ menuText: "暫存文書", sourceType: NOTIFICATION_SOURCE_TYPE.DOCUMENT, router: NOTIFICATIONS_ROUTER.TEMP_DOC },
	{ menuText: "新版本", sourceType: NOTIFICATION_SOURCE_TYPE.VERSION, router: NOTIFICATIONS_ROUTER.VERSION_UPDATE },
	{ menuText: "循環訂單", sourceType: NOTIFICATION_SOURCE_TYPE.CYCLEPURCHASE, router: NOTIFICATIONS_ROUTER.CYCLE_PURCHASE },
];
